import {
  createWebSessionStorageAdapter,
  initPlatform,
  setAccessTokenProvider,
} from '@ego/api';

const INIT_FLAG = '__ego_api_initialized__';
const TOKEN_KEY = 'ego-auth-token';

export function getStoredToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function storeToken(token) {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    // Storage unavailable — session lives for this page only
  }
}

export function clearStoredToken() {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    // ignore
  }
}

export function initWebApi() {
  if (globalThis[INIT_FLAG]) return;

  initPlatform({
    serverBaseUrl: import.meta.env.VITE_CHAT_API_URL || 'http://localhost:3001',
    mediaBaseUrl: import.meta.env.VITE_MEDIA_BASE_URL || 'https://pub-4c5ba9bec35048ac8ae6de52454c2fda.r2.dev',
    storage: createWebSessionStorageAdapter(),
  });

  setAccessTokenProvider(() => getStoredToken());

  globalThis[INIT_FLAG] = true;
}

initWebApi();
